import { render } from "./ChromaView.vue?vue&type=template&id=93e66086&scoped=true&ts=true"
import script from "./ChromaView.vue?vue&type=script&lang=ts"
export * from "./ChromaView.vue?vue&type=script&lang=ts"

import "./ChromaView.vue?vue&type=style&index=0&id=93e66086&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93e66086"]])

export default __exports__